<template>
    <div class='page'>
      

      <div>{{city}}</div>
      <van-button type="primary" @click="setcity" block >设置城市</van-button>
      
      <van-button style="margin-top:5px;" type="primary" @click="gotoIndex" block >goto</van-button>
    </div>

</template>
<script>
import {Button} from 'vant';
import { mapState, mapActions } from 'vuex'


export default {
        name: "index",
        components:{
           [Button.name]:Button,
        },
        
        data(){
            return {
              lists:[]
            }
        },
        // 方法一
        computed1: mapState({
          city: state => state.city.cityName
        }),
        // 方法二
        computed: {
          ...mapState({
            city: state => state.city.cityName
          })
        },
        
        mounted() {
          //方法三 
          //this.$store.state.city.cityName
          
          this.lists = this.$store.getters.getPlayLists
          console.log("----",this.$store.state.city.cityName)
        },
        methods:{
          setcity(){
            this.$store.dispatch("city/setCityName", '深圳');
          },
          gotoIndex(){
            this.$router.push(this.util.urlPrefix+'/test/index?token='+this.util.token)
          }
        }
    }

</script>
